import React, { useEffect, useRef, useState } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import MenuPortal from '../MenuPortal';
import './LaneHeader.css';
import { useI18n } from '../../../../i18n';

const LaneHeader = ({
	title,
	cards,
	updateTitle,
	onDelete,
	canAddLanes,
	laneDraggable,
	t,
}) => {
	const { t: tr } = useI18n();
	const [menuOpen, setMenuOpen] = useState(false);
	const [editing, setEditing] = useState(false);
	const [draft, setDraft] = useState(title || '');
	const menuBtnRef = useRef(null);
	const menuPopRef = useRef(null);
	const count = Array.isArray(cards) ? cards.length : 0;

	useEffect(() => {
		setDraft(title || '');
	}, [title]);

	useEffect(() => {
		if (!menuOpen) return undefined;
		const onDoc = (event) => {
			const target = event.target;
			if (menuBtnRef.current && menuBtnRef.current.contains(target)) return;
			if (menuPopRef.current && menuPopRef.current.contains(target)) return;
			setMenuOpen(false);
		};
		document.addEventListener('mousedown', onDoc);
		return () => document.removeEventListener('mousedown', onDoc);
	}, [menuOpen]);

	const commitTitle = () => {
		const next = (draft || '').trim();
		setEditing(false);
		if (next && next !== title && updateTitle) updateTitle(next);
		else setDraft(title || '');
	};

	const showMenu = Boolean(canAddLanes || onDelete || updateTitle);

	return (
		<div className={`board-lane-header${menuOpen ? ' is-open' : ''}`}>
			{editing ? (
				<input
					className="board-lane-title-input"
					value={draft}
					autoFocus
					onChange={(e) => setDraft(e.target.value)}
					onBlur={commitTitle}
					onKeyDown={(e) => {
						if (e.key === 'Enter') commitTitle();
						if (e.key === 'Escape') {
							setDraft(title || '');
							setEditing(false);
						}
					}}
				/>
			) : (
				<h3
					className="board-lane-title"
					draggable={laneDraggable}
					onDoubleClick={(e) => {
						e.stopPropagation();
						setEditing(true);
					}}
					title="Double-click to rename"
				>
					{title}
				</h3>
			)}
			<span className="board-lane-count">{count}</span>
			{showMenu && (
				<div className="board-lane-menu">
					<button
						ref={menuBtnRef}
						type="button"
						className="board-lane-menu-btn"
						aria-label={t ? t('Lane actions') : 'Lane actions'}
						aria-expanded={menuOpen}
						onMouseDown={(e) => e.stopPropagation()}
						onClick={(e) => {
							e.stopPropagation();
							setMenuOpen((open) => !open);
						}}
					>
						<FaEllipsisH />
					</button>
					{menuOpen && (
						<MenuPortal anchorRef={menuBtnRef} menuRef={menuPopRef} width={168}>
							<div className="board-lane-menu-pop">
								<button
									type="button"
									role="menuitem"
									onClick={(e) => {
										e.stopPropagation();
										setMenuOpen(false);
										setEditing(true);
									}}
								>
									{tr('board.rename')}
								</button>
								<p className="board-lane-menu-hint">{tr('board.dragHint')}</p>
								<button
									type="button"
									role="menuitem"
									onClick={(e) => {
										e.stopPropagation();
										setMenuOpen(false);
										if (onDelete) onDelete();
									}}
								>
									{tr('board.deleteList')}
								</button>
							</div>
						</MenuPortal>
					)}
				</div>
			)}
		</div>
	);
};

export default LaneHeader;
